import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFileXmark = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m18.093 6.283-2.624-2.624A2.26 2.26 0 0 0 13.877 3H7.5a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h9a2.257 2.257 0 0 0 2.25-2.25V7.873c0-.594-.235-1.168-.657-1.59m-1.03 12.467c0 .31-.252.563-.563.563h-9a.563.563 0 0 1-.562-.563V5.255c0-.311.251-.563.562-.563h5.625V7.5c0 .621.504 1.125 1.125 1.125h2.813zm-3.41-7.348L12 13.058l-1.684-1.656a.844.844 0 1 0-1.193 1.194l1.685 1.654-1.653 1.653a.844.844 0 1 0 1.193 1.194L12 15.442l1.653 1.653a.844.844 0 1 0 1.194-1.193l-1.655-1.652 1.653-1.653a.844.844 0 0 0-1.193-1.195"
    }));
export default SvgFileXmark;
